import Collapsible from 'creative-ui/uikit/Collapsible';
import Cta from 'creative-ui/uikit/Cta';
import CtaContainer from 'creative-ui/uikit/CtaContainer';
import SvgKey from 'creative-ui/uikit/svg/security/key';
import { useTranslation } from 'react-i18next';

import Flex from '@/components/Layout/Flex/Flex';
import { PasskeyCheckmarks } from '@/components/PasskeyCheckmarks/PasskeyCheckmarks';
import { Text } from '@/components/Typography/Text/Text';
import { PASSKEY_ENROLMENT_NAMESPACE } from '@/i18n/namespaces';
import { trackClick } from '@/lib/tagging';
import { usePasskeyEnrollmentManager } from '@/screens/passkey-enrollment/hooks/usePasskeyEnrollmentManager';

export function PasskeyForm() {
  const { continuePasskeyEnrollment, abortPasskeyEnrollment } =
    usePasskeyEnrollmentManager();
  const { t } = useTranslation(PASSKEY_ENROLMENT_NAMESPACE);

  const handlePasskeyEnrollment = async () => {
    trackClick('mfa/passkey/setup/create');
    await continuePasskeyEnrollment();
  };

  const handlePasskeyAbort = async () => {
    trackClick('mfa/passkey/setup/skip');
    await abortPasskeyEnrollment();
  };

  return (
    <Flex direction="column" gapY={16}>
      <PasskeyCheckmarks translationNamespace={PASSKEY_ENROLMENT_NAMESPACE} />

      <Collapsible title={t('accordion.summary')} titleTag="h2" theme="blue">
        <Flex direction="column" gapY={8}>
          <div>
            <Text bold>{t('accordion.content.email')}</Text>
            <Text>{t('accordion.content.passkey')}</Text>
          </div>
          <div>
            <Text bold>{t('accordion.content.create')}</Text>
            <Text>{t('accordion.content.method')}</Text>
          </div>
        </Flex>
      </Collapsible>

      <CtaContainer stack>
        <Cta type="primary" svgLeft={SvgKey} onClick={handlePasskeyEnrollment}>
          {t('login')}
        </Cta>
      </CtaContainer>

      <CtaContainer stack>
        <Cta type="ghost-inline" onClick={handlePasskeyAbort}>
          {t('skip')}
        </Cta>
      </CtaContainer>
    </Flex>
  );
}
